import React from 'react';
import { NavLink } from 'react-router-dom';

export default function MerchantRegistration() {
	return (
		<div className="px-1 2xl:px-10 pt-20 lg:pt-10">
			<h1 className="mb-10">Merchant Registration</h1>
			<div className="w-full h-[1px] bg-gray-400" />

			<div className="flex w-100 flex-row mt-5 pb-20">
				<div className="lg:basis-4/5 w-full">
					<div id="registeration">
						<h2 className="mb-5">Registration</h2>
						<h3 className="">
							To register as a Merchant with SPay, you need to provide some
							required information:
						</h3>
						<div className="mt-2 ml-2 md:ml-5">
							<ol className="">
								<li className="">1. Business Name</li>
								<li className="">2. Business Email Address</li>
								<li className="">3. Country</li>
								<li className="">
									4. Password (password must be at least 8 characters long and
									contain at least one special character.)
								</li>
							</ol>
						</div>
						<div className="flex flex-col justify-center items-center mt-2">
							<img
								src={require('../../assets/Image/MerchantRegistration1.png')}
								alt="MerchantReg"
								className="w-full mt-5 mb-2"
								width={800}
								height={528}
							/>
							<p className="text-center mb-8">Registration Page</p>
						</div>
					</div>
					<div id="login">
						<h2 className="mb-2">Login</h2>
						<p className="mb-2">
							After you&apos;ve submitted your business information on the
							Registration Page, the automatic redirect will take you to the
							Login page and a welcome email will be sent to the business email
							used for the registration
						</p>
						<p className="">
							To login, enter your login credential supplied during
							registration.
						</p>
						<div className="mt-2 ml-2 md:ml-5">
							<ol className="text-[#7c7c7d]">
								<li className="text-sm">1. Business Email Address</li>
								<li className="text-sm">2. Password</li>
							</ol>
						</div>
						<div className="flex flex-col justify-center items-center mt-2">
							<img
								src={require('../../assets/Image/MerchantRegistration2.png')}
								alt="MerchantReg"
								className="w-full mt-5 mb-2"
								width={800}
								height={453}
							/>
							<p className="text-center mb-8">Login Page</p>
						</div>
					</div>
					<div id="business-information">
						<h2 className="mb-2">Business Information</h2>
						<p className="">
							The Onboarding page stands as an entry-level validator mechanism
							that checked merchant have submitted all required information
							before merchant can have access to the dashboard of its account.
						</p>
						<p className="mt-2">
							If you don&apos;t provide all the required information you will
							always remain on the business infotmtion page until you do.
						</p>
						<div className="mt-2 ml-5">
							<ol>
								<li className="">1. Business Name</li>
								<li className="">2. Business Email Address</li>
								<li className="">3. Country</li>
								<li className="">
									4. Password (password must be at least 8 characters long and
									contain at least one special character.)
								</li>
								<li className="">5. Business Category</li>
								<li className="">6. Business Type</li>
								<li className="">7. About Business - Optional</li>
							</ol>
						</div>
						<p className="mt-2">
							Immediately after you&apos;e created an account, you will be
							prompted to create a business. To do so, follow the steps below:
						</p>
						<p className="">
							Enter your company name and choose your business category. If you
							are a registered business, ensure that your business name is
							identical with the name in your registration documents.​
						</p>
						<div className="flex flex-col justify-center items-center mt-2">
							<img
								src={require('../../assets/Image/MerchantRegistration3.png')}
								alt="MerchantReg"
								className="w-full mt-5 mb-2"
								width={800}
								height={990}
							/>
							<p className="text-center mb-8">Business Information</p>
						</div>
					</div>
					<div className="border-t-2 flex flex-row justify-between ">
						<div className="mt-5">
							<NavLink to="/">
								<p className="text-[16px] text-[#4f5866]">← Introductions</p>
							</NavLink>
						</div>
						<div className="mt-5">
							<NavLink to="/merchant-kyc">
								<p className="text-[#4f5866] text-[16px]">Merchant KYC →</p>
							</NavLink>
						</div>
					</div>
				</div>
				<div className="hidden lg:flex lg:basis-1/5 lg:overscroll-none lg:min-h-full overflow-clip">
					<div className="lg:w-40 2xl:w-52 lg:fixed lg:top-52 lg:right-1 xl:right-4 2xl:right-10">
						<div className="mb-2">
							<h3>Table Of Contents</h3>
						</div>
						<div className="">
							<a href="#registeration">
								<p className="text-sm text-[#637288] mb-1">Registration</p>
							</a>
							<a href="#login">
								<p className="text-sm text-[#637288] mb-1">Login</p>
							</a>
							<a href="#business-information">
								<p className="text-sm text-[#637288]">Business Information</p>
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
